export default class SpecStatus {
  static get AvailableNow() {
    return this.getInstance('A');
  }

  static get Model() {
    return this.getInstance('M');
  }

  static get ReadyToBuild() {
    return this.getInstance('R');
  }

  static get UnderConstruction() {
    return this.getInstance('UC');
  }

  static get HotDeals() {
    return this.getInstance('H');
  }

  static fromKey(key) {
    const statusMap = {
      R: SpecStatus.ReadyToBuild,
      A: SpecStatus.AvailableNow,
      UC: SpecStatus.UnderConstruction,
      M: SpecStatus.Model,
      H: SpecStatus.HotDeals,
    };

    return statusMap[key];
  }

  static getInstance(key) {
    if (!this.instances[key]) {
      this.instances[key] = new SpecStatus(key);
    }
    return this.instances[key];
  }

  constructor(name) {
    this.name = name;
  }

  toString() {
    return `${this.name}`;
  }
}

Object.defineProperty(SpecStatus, 'instances', { value: {} });
